<template>
    <v-menu offset-y location="bottom">
        <template v-slot:activator="{ props, isActive }">
            <v-btn
                color="secondary"
                v-bind="props"
                elevation="0"
                rounded="sm"
                class="ml-1 px-1"
                variant="plain"
                size="small"
            >
                <v-icon v-if="icon" class="mr-2" size="small" :icon="icon" />
                <span v-if="title">{{ title }}</span>
                <v-icon class="ml-2" size="x-small">
                    {{ isActive ? "$fa-angle-down" : "$fa-angle-up" }}
                </v-icon>
            </v-btn>
        </template>
        <slot> </slot>
    </v-menu>
</template>
<script lang="ts">
import { Prop } from "vue-facing-decorator";
import { Component, Vue, toNative } from "vue-facing-decorator";

@Component
export class CustomToolbarDropdown extends Vue {
    @Prop({ default: null }) icon: string;
    @Prop({ default: null }) title: string;
}

export default toNative(CustomToolbarDropdown);
</script>
<style lang="css" scoped></style>
